export const SETTINGS = {
  // Three.js
  CAMERA: {
    FOV: 70,
    ASPECT: 1,
    NEAR: 0.1,
    FAR: 100,
  },
  PARTICLE: {
    PARTICLE_COUNT: 3000,
    FRAME_PARTICLE_COUNT: 1000,
    POSITION: {
      X: 0.2,
      Y: 0.2,
      Z: 0.2,
    },
    VELOCITY: {
      X: 1.0,
      Y: 4.5,
      Z: 0.0,
    },
  }
}
